import { c as _c } from "react/compiler-runtime";
import { StoreImageEnum } from '@systemeio/digital-store-shared';
import { LanguageCodeEnum } from '@systemeio/ui';
import { defaultDigitalProductErrors } from 'modules/digital-product/constants/default-values';
import { useDigitalProduct } from 'modules/digital-product/hooks/use-digital-product';
import { ResourceFileType, useResourceFiles } from 'modules/digital-product/hooks/use-resource-files';
import { DigitalProductChangeInterface, DigitalProductErrorInterface } from 'modules/digital-product/types/digital-product-interface';
import ItemActions from 'modules/stores/store/components/item-actions';
import ItemTabs, { ItemTabType } from 'modules/stores/store/components/item-tabs';
import ThankYouTab from 'modules/stores/store/components/tabs/thank-you-tab';
import { STORE_ITEM_CLASS_NAME } from 'modules/stores/store/constants/store-item-class-name';
import Thumbnail from 'modules/stores/store/content/product/components/thumbnail';
import Checkout from 'modules/stores/store/content/product/digital-product/components/checkout';
import { DigitalDownload } from 'modules/stores/store/content/product/digital-product/product-download/components/digital-download';
import { defaultErrors } from 'modules/stores/store/content/product/digital-product/product-download/constants/default-errors';
import { defaultValues } from 'modules/stores/store/content/product/digital-product/product-download/constants/default-values';
import { ProductDownloadTabEnum, tabLocoKeys } from 'modules/stores/store/content/product/digital-product/product-download/enum/product-download-tab-enum';
import { useErrorMessageInTabs } from 'modules/stores/store/content/product/digital-product/product-download/hooks/use-error-message-in-tabs';
import { getNextTab } from 'modules/stores/store/content/product/digital-product/product-download/utils/get-next-tab-product-download';
import { ProductDownloadItemEditType, ProductDownloadItemErrorsType, ProductDownloadItemViewType } from 'modules/stores/store/content/product/types/product-interface';
import { useStoreEditItemContext } from 'modules/stores/store/context/store-item-edit-context';
import { useStore } from 'modules/stores/store/hooks/use-store';
import { useStoreContactFields } from 'modules/stores/store/hooks/use-store-contact-fields';
import { StoreId } from 'modules/stores/types/stores-interface';
import { FC, useEffect, useState } from 'react';
import { ConfirmationModalBeforeExit } from 'shared/confirmation-modal-before-exit/component';
import { useLocoTranslation } from 'shared/hooks/use-loco-translation';
import { deepCompare } from 'shared/utils/deepCompare';
import { twMerge } from 'tailwind-merge';
import { useSaveItemProduct } from '../hooks/use-save-item-product';
import { digitalProductInitFields } from '../constants/mandatory-fields';
interface Props {
  storeId: StoreId;
  item?: ProductDownloadItemViewType;
  languageCode: LanguageCodeEnum;
}
const Edit: FC<Props> = t0 => {
  const $ = _c(165);
  const {
    storeId,
    item,
    languageCode
  } = t0;
  const {
    t
  } = useLocoTranslation();
  const [tab, setTab] = useState(ProductDownloadTabEnum.thumbnail);
  const {
    data: storeView
  } = useStore(storeId);
  let t1;
  if ($[0] !== languageCode || $[1] !== t) {
    t1 = t("dashboard.store.product.download.title_default", {
      lng: languageCode
    });
    $[0] = languageCode;
    $[1] = t;
    $[2] = t1;
  } else {
    t1 = $[2];
  }
  let t2;
  if ($[3] !== languageCode || $[4] !== t) {
    t2 = t("dashboard.store.product.download.subtitle_default", {
      lng: languageCode
    });
    $[3] = languageCode;
    $[4] = t;
    $[5] = t2;
  } else {
    t2 = $[5];
  }
  let t3;
  if ($[6] !== languageCode || $[7] !== t) {
    t3 = t("dashboard.store.product.download.button_default", {
      lng: languageCode
    });
    $[6] = languageCode;
    $[7] = t;
    $[8] = t3;
  } else {
    t3 = $[8];
  }
  let t4;
  if ($[9] !== languageCode || $[10] !== t) {
    t4 = t("dashboard.store.product.checkout.title_default", {
      lng: languageCode
    });
    $[9] = languageCode;
    $[10] = t;
    $[11] = t4;
  } else {
    t4 = $[11];
  }
  let t5;
  if ($[12] !== languageCode || $[13] !== t) {
    t5 = t("dashboard.store.product.checkout.subtitle_default_tip-tap", {
      lng: languageCode
    });
    $[12] = languageCode;
    $[13] = t;
    $[14] = t5;
  } else {
    t5 = $[14];
  }
  let t6;
  if ($[15] !== languageCode || $[16] !== t) {
    t6 = t("dashboard.store.product.checkout.button_default", {
      lng: languageCode
    });
    $[15] = languageCode;
    $[16] = t;
    $[17] = t6;
  } else {
    t6 = $[17];
  }
  let t7;
  if ($[18] !== t4 || $[19] !== t5 || $[20] !== t6) {
    t7 = {
      ...defaultValues.checkoutPage,
      title: t4,
      description: t5,
      buttonTitle: t6
    };
    $[18] = t4;
    $[19] = t5;
    $[20] = t6;
    $[21] = t7;
  } else {
    t7 = $[21];
  }
  let t8;
  if ($[22] !== languageCode || $[23] !== t) {
    t8 = t("dashboard.store.product.download.thank_you.title_default", {
      lng: languageCode
    });
    $[22] = languageCode;
    $[23] = t;
    $[24] = t8;
  } else {
    t8 = $[24];
  }
  let t9;
  if ($[25] !== languageCode || $[26] !== t) {
    t9 = t("dashboard.store.product.download.thank_you.subtitle_default", {
      lng: languageCode
    });
    $[25] = languageCode;
    $[26] = t;
    $[27] = t9;
  } else {
    t9 = $[27];
  }
  let t10;
  if ($[28] !== t8 || $[29] !== t9) {
    t10 = {
      title: t8,
      text: t9
    };
    $[28] = t8;
    $[29] = t9;
    $[30] = t10;
  } else {
    t10 = $[30];
  }
  let t11;
  if ($[31] !== t1 || $[32] !== t10 || $[33] !== t2 || $[34] !== t3 || $[35] !== t7) {
    t11 = {
      ...defaultValues,
      draft: false,
      title: t1,
      subTitle: t2,
      buttonTitle: t3,
      checkoutPage: t7,
      thankYouPage: t10
    };
    $[31] = t1;
    $[32] = t10;
    $[33] = t2;
    $[34] = t3;
    $[35] = t7;
    $[36] = t11;
  } else {
    t11 = $[36];
  }
  const defaultValuesWithLoco = t11;
  let t12;
  if ($[37] !== languageCode || $[38] !== t) {
    t12 = t("dashboard.store.product.download.title_default", {
      lng: languageCode
    });
    $[37] = languageCode;
    $[38] = t;
    $[39] = t12;
  } else {
    t12 = $[39];
  }
  let t13;
  let t14;
  if ($[40] === Symbol.for("react.memo_cache_sentinel")) {
    t13 = [];
    t14 = [];
    $[40] = t13;
    $[41] = t14;
  } else {
    t13 = $[40];
    t14 = $[41];
  }
  let t15;
  if ($[42] !== t12) {
    t15 = {
      name: t12,
      resources: t13,
      pricePlans: t14,
      confirmationEmail: null
    };
    $[42] = t12;
    $[43] = t15;
  } else {
    t15 = $[43];
  }
  const defaultProductValuesWithLoco = t15;
  const [tempState, setTempState] = useState(item || defaultValuesWithLoco);
  const {
    data: digitalProduct
  } = useDigitalProduct(tempState.checkoutPage.digitalProductId);
  const [tempProduct, setTempProduct] = useState(digitalProduct ?? defaultProductValuesWithLoco);
  const [isDataSaved, setIsDataSaved] = useState(true);
  let t16;
  let t17;
  if ($[44] !== digitalProduct) {
    t16 = () => {
      if (digitalProduct) {
        setTempProduct(digitalProduct);
      }
    };
    t17 = [digitalProduct];
    $[44] = digitalProduct;
    $[45] = t16;
    $[46] = t17;
  } else {
    t16 = $[45];
    t17 = $[46];
  }
  useEffect(t16, t17);
  let t18;
  if ($[47] === Symbol.for("react.memo_cache_sentinel")) {
    t18 = [];
    $[47] = t18;
  } else {
    t18 = $[47];
  }
  const [tempFiles, setTempFiles] = useState(t18);
  const t19 = useResourceFiles(tempProduct.id ?? undefined);
  let resourceFetcher;
  let resourceFiles;
  if ($[48] !== t19) {
    ({
      data: resourceFiles,
      ...resourceFetcher
    } = t19);
    $[48] = t19;
    $[49] = resourceFetcher;
    $[50] = resourceFiles;
  } else {
    resourceFetcher = $[49];
    resourceFiles = $[50];
  }
  const isResourceFilesLoading = resourceFetcher.isLoading || resourceFetcher.isValidating;
  let t20;
  let t21;
  if ($[51] !== resourceFiles) {
    t20 = () => {
      resourceFiles && setTempFiles(resourceFiles);
    };
    t21 = [resourceFiles];
    $[51] = resourceFiles;
    $[52] = t20;
    $[53] = t21;
  } else {
    t20 = $[52];
    t21 = $[53];
  }
  useEffect(t20, t21);
  const {
    errors: initialErrors,
    setErrors: setEditItemErrors
  } = useStoreEditItemContext();
  let t22;
  if ($[54] !== initialErrors) {
    t22 = {
      ...defaultErrors,
      ...initialErrors
    };
    $[54] = initialErrors;
    $[55] = t22;
  } else {
    t22 = $[55];
  }
  const [errors, setErrors] = useState(t22);
  const [productErrors, setProductErrors] = useState(defaultDigitalProductErrors);
  let t23;
  if ($[56] !== setEditItemErrors) {
    t23 = () => () => {
      setEditItemErrors({});
    };
    $[56] = setEditItemErrors;
    $[57] = t23;
  } else {
    t23 = $[57];
  }
  let t24;
  if ($[58] === Symbol.for("react.memo_cache_sentinel")) {
    t24 = [];
    $[58] = t24;
  } else {
    t24 = $[58];
  }
  useEffect(t23, t24);
  let t25;
  if ($[59] === Symbol.for("react.memo_cache_sentinel")) {
    t25 = fields => setTempState(prev => ({
      ...prev,
      checkoutPage: {
        ...prev.checkoutPage,
        fields
      }
    }));
    $[59] = t25;
  } else {
    t25 = $[59];
  }
  let t26;
  if ($[60] !== tempState.checkoutPage.fields) {
    t26 = {
      savedFields: tempState.checkoutPage.fields,
      initFields: digitalProductInitFields,
      onChange: t25
    };
    $[60] = tempState.checkoutPage.fields;
    $[61] = t26;
  } else {
    t26 = $[61];
  }
  useStoreContactFields(t26);
  let t27;
  if ($[62] !== storeId || $[63] !== tempProduct || $[64] !== tempState) {
    t27 = {
      tempState,
      tempProduct,
      setTempProduct,
      setTempState,
      storeId,
      setErrors,
      setProductErrors,
      defaultErrors
    };
    $[62] = storeId;
    $[63] = tempProduct;
    $[64] = tempState;
    $[65] = t27;
  } else {
    t27 = $[65];
  }
  const {
    onPublish,
    isFetchingPublish,
    isFetchingDraft,
    onSaveDraft
  } = useSaveItemProduct(t27);
  const isLastTab = tab === ProductDownloadTabEnum.thank_you;
  const isCreatingProcess = !item;
  const {
    getTabsWithErrors
  } = useErrorMessageInTabs();
  let t28;
  if ($[66] !== errors || $[67] !== getTabsWithErrors || $[68] !== productErrors) {
    t28 = getTabsWithErrors({
      errors,
      digitalProductErrors: productErrors
    });
    $[66] = errors;
    $[67] = getTabsWithErrors;
    $[68] = productErrors;
    $[69] = t28;
  } else {
    t28 = $[69];
  }
  const errorsByTab = t28;
  const isNew = !item;
  const inReadyToSave = isNew ? true : !!digitalProduct;
  let t29;
  if ($[70] !== t) {
    t29 = t(tabLocoKeys[ProductDownloadTabEnum.thumbnail]);
    $[70] = t;
    $[71] = t29;
  } else {
    t29 = $[71];
  }
  const t30 = errorsByTab[ProductDownloadTabEnum.thumbnail];
  let t31;
  if ($[72] !== t29 || $[73] !== t30) {
    t31 = {
      key: ProductDownloadTabEnum.thumbnail,
      caption: t29,
      hasError: t30
    };
    $[72] = t29;
    $[73] = t30;
    $[74] = t31;
  } else {
    t31 = $[74];
  }
  let t32;
  if ($[75] !== t) {
    t32 = t(tabLocoKeys[ProductDownloadTabEnum.digital_download]);
    $[75] = t;
    $[76] = t32;
  } else {
    t32 = $[76];
  }
  const t33 = errorsByTab[ProductDownloadTabEnum.digital_download];
  let t34;
  if ($[77] !== t32 || $[78] !== t33) {
    t34 = {
      key: ProductDownloadTabEnum.digital_download,
      caption: t32,
      hasError: t33
    };
    $[77] = t32;
    $[78] = t33;
    $[79] = t34;
  } else {
    t34 = $[79];
  }
  let t35;
  if ($[80] !== t) {
    t35 = t(tabLocoKeys[ProductDownloadTabEnum.checkout]);
    $[80] = t;
    $[81] = t35;
  } else {
    t35 = $[81];
  }
  const t36 = errorsByTab[ProductDownloadTabEnum.checkout];
  let t37;
  if ($[82] !== t35 || $[83] !== t36) {
    t37 = {
      key: ProductDownloadTabEnum.checkout,
      caption: t35,
      hasError: t36
    };
    $[82] = t35;
    $[83] = t36;
    $[84] = t37;
  } else {
    t37 = $[84];
  }
  let t38;
  if ($[85] !== t) {
    t38 = t(tabLocoKeys[ProductDownloadTabEnum.thank_you]);
    $[85] = t;
    $[86] = t38;
  } else {
    t38 = $[86];
  }
  const t39 = errorsByTab[ProductDownloadTabEnum.thank_you];
  let t40;
  if ($[87] !== t38 || $[88] !== t39) {
    t40 = {
      key: ProductDownloadTabEnum.thank_you,
      caption: t38,
      hasError: t39
    };
    $[87] = t38;
    $[88] = t39;
    $[89] = t40;
  } else {
    t40 = $[89];
  }
  let t41;
  if ($[90] !== t31 || $[91] !== t34 || $[92] !== t37 || $[93] !== t40) {
    t41 = [t31, t34, t37, t40];
    $[90] = t31;
    $[91] = t34;
    $[92] = t37;
    $[93] = t40;
    $[94] = t41;
  } else {
    t41 = $[94];
  }
  const tabs = t41;
  let t42;
  if ($[95] !== defaultProductValuesWithLoco || $[96] !== defaultValuesWithLoco || $[97] !== digitalProduct || $[98] !== item || $[99] !== resourceFiles || $[100] !== tempFiles || $[101] !== tempProduct || $[102] !== tempState) {
    t42 = () => {
      if (item || resourceFiles || digitalProduct) {
        setIsDataSaved(deepCompare({
          item: tempState,
          digitalProduct: tempProduct,
          resourceFiles: tempFiles
        }, {
          item: item ?? defaultValuesWithLoco,
          digitalProduct: digitalProduct ?? defaultProductValuesWithLoco,
          resourceFiles: resourceFiles ?? []
        }));
      } else {
        setIsDataSaved(deepCompare({
          item: tempState,
          digitalProduct: tempProduct,
          resourceFiles: tempFiles
        }, {
          item: {
            ...defaultValuesWithLoco,
            checkoutPage: {
              ...defaultValuesWithLoco.checkoutPage,
              fields: tempState.checkoutPage.fields,
              description: tempState.checkoutPage.description
            },
            style: tempState.style
          },
          digitalProduct: defaultProductValuesWithLoco,
          resourceFiles: []
        }));
      }
    };
    $[95] = defaultProductValuesWithLoco;
    $[96] = defaultValuesWithLoco;
    $[97] = digitalProduct;
    $[98] = item;
    $[99] = resourceFiles;
    $[100] = tempFiles;
    $[101] = tempProduct;
    $[102] = tempState;
    $[103] = t42;
  } else {
    t42 = $[103];
  }
  let t43;
  if ($[104] !== tempFiles || $[105] !== tempProduct || $[106] !== tempState) {
    t43 = [tempState, tempProduct, tempFiles];
    $[104] = tempFiles;
    $[105] = tempProduct;
    $[106] = tempState;
    $[107] = t43;
  } else {
    t43 = $[107];
  }
  useEffect(t42, t43);
  let t44;
  if ($[108] === Symbol.for("react.memo_cache_sentinel")) {
    t44 = twMerge(STORE_ITEM_CLASS_NAME, "flex flex-col gap-5");
    $[108] = t44;
  } else {
    t44 = $[108];
  }
  let t45;
  if ($[109] !== tab || $[110] !== tabs) {
    t45 = <ItemTabs tabs={tabs} currentTab={tab} setTab={setTab} />;
    $[109] = tab;
    $[110] = tabs;
    $[111] = t45;
  } else {
    t45 = $[111];
  }
  let t46;
  if ($[112] !== errors || $[113] !== tab || $[114] !== tempState) {
    t46 = tab === ProductDownloadTabEnum.thumbnail && <Thumbnail imageType={StoreImageEnum.product_download_thumbnail} tempState={tempState} setTempState={setTempState} errors={errors} />;
    $[112] = errors;
    $[113] = tab;
    $[114] = tempState;
    $[115] = t46;
  } else {
    t46 = $[115];
  }
  let t47;
  if ($[116] !== errors || $[117] !== productErrors || $[118] !== storeView?.currency || $[119] !== storeView?.paymentMethods || $[120] !== tab || $[121] !== tempProduct || $[122] !== tempState) {
    t47 = tab === ProductDownloadTabEnum.checkout && <Checkout tempState={tempState} setTempState={setTempState} tempProduct={tempProduct} setTempProduct={setTempProduct} errors={errors} pricePlanErrors={productErrors.pricePlans} currency={storeView?.currency} paymentMethods={storeView?.paymentMethods} imageType={StoreImageEnum.product_download_cover} />;
    $[116] = errors;
    $[117] = productErrors;
    $[118] = storeView?.currency;
    $[119] = storeView?.paymentMethods;
    $[120] = tab;
    $[121] = tempProduct;
    $[122] = tempState;
    $[123] = t47;
  } else {
    t47 = $[123];
  }
  let t48;
  if ($[124] !== errors || $[125] !== isResourceFilesLoading || $[126] !== productErrors || $[127] !== tab || $[128] !== tempFiles || $[129] !== tempProduct) {
    t48 = tab === ProductDownloadTabEnum.digital_download && <DigitalDownload tempProduct={tempProduct} setTempProduct={setTempProduct} tempFiles={tempFiles} setTempFiles={setTempFiles} isResourceFilesLoading={isResourceFilesLoading} productItemErrors={errors} digitalProductErrors={productErrors} />;
    $[124] = errors;
    $[125] = isResourceFilesLoading;
    $[126] = productErrors;
    $[127] = tab;
    $[128] = tempFiles;
    $[129] = tempProduct;
    $[130] = t48;
  } else {
    t48 = $[130];
  }
  let t49;
  if ($[131] !== errors || $[132] !== tab || $[133] !== tempState.thankYouPage) {
    t49 = tab === ProductDownloadTabEnum.thank_you && <ThankYouTab thankYouPage={tempState.thankYouPage} onChange={thankYouPage => setTempState(prev_0 => ({
      ...prev_0,
      thankYouPage
    }))} errors={errors} />;
    $[131] = errors;
    $[132] = tab;
    $[133] = tempState.thankYouPage;
    $[134] = t49;
  } else {
    t49 = $[134];
  }
  const t50 = !inReadyToSave;
  const t51 = isLastTab || !isCreatingProcess ? onPublish : undefined;
  let t52;
  if ($[135] !== isFetchingPublish || $[136] !== t50 || $[137] !== t51) {
    t52 = {
      disabled: t50,
      onClick: t51,
      isFetching: isFetchingPublish
    };
    $[135] = isFetchingPublish;
    $[136] = t50;
    $[137] = t51;
    $[138] = t52;
  } else {
    t52 = $[138];
  }
  const t53 = !inReadyToSave;
  let t54;
  if ($[139] !== isFetchingDraft || $[140] !== onSaveDraft || $[141] !== t53) {
    t54 = {
      disabled: t53,
      onClick: onSaveDraft,
      isFetching: isFetchingDraft
    };
    $[139] = isFetchingDraft;
    $[140] = onSaveDraft;
    $[141] = t53;
    $[142] = t54;
  } else {
    t54 = $[142];
  }
  let t55;
  if ($[143] !== isCreatingProcess || $[144] !== isLastTab) {
    t55 = isCreatingProcess && !isLastTab ? () => setTab(getNextTab) : undefined;
    $[143] = isCreatingProcess;
    $[144] = isLastTab;
    $[145] = t55;
  } else {
    t55 = $[145];
  }
  let t56;
  if ($[146] !== t55) {
    t56 = {
      onClick: t55
    };
    $[146] = t55;
    $[147] = t56;
  } else {
    t56 = $[147];
  }
  let t57;
  if ($[148] !== t52 || $[149] !== t54 || $[150] !== t56) {
    t57 = <ItemActions publish={t52} saveDraft={t54} next={t56} />;
    $[148] = t52;
    $[149] = t54;
    $[150] = t56;
    $[151] = t57;
  } else {
    t57 = $[151];
  }
  let t58;
  if ($[152] !== t) {
    t58 = t("dashboard.store.confirmation_message_before_exit");
    $[152] = t;
    $[153] = t58;
  } else {
    t58 = $[153];
  }
  const t59 = isDataSaved || isFetchingDraft || isFetchingPublish;
  let t60;
  if ($[154] !== t58 || $[155] !== t59) {
    t60 = <ConfirmationModalBeforeExit confirmationText={t58} hideModal={t59} />;
    $[154] = t58;
    $[155] = t59;
    $[156] = t60;
  } else {
    t60 = $[156];
  }
  let t61;
  if ($[157] !== t45 || $[158] !== t46 || $[159] !== t47 || $[160] !== t48 || $[161] !== t49 || $[162] !== t57 || $[163] !== t60) {
    t61 = <div className={t44}>{t45}{t46}{t47}{t48}{t49}{t57}{t60}</div>;
    $[157] = t45;
    $[158] = t46;
    $[159] = t47;
    $[160] = t48;
    $[161] = t49;
    $[162] = t57;
    $[163] = t60;
    $[164] = t61;
  } else {
    t61 = $[164];
  }
  return t61;
};
export default Edit;